<template>
  <footer class="footer" v-if="currentRegion">
    <div class="footer-content">
      <div class="footer-text">
        <p>© {{ config.companyName }} {{ $t('message.footer') }}</p>
        <p v-if="config.footer && config.footer.icp">备案号：{{ config.footer.icp }}</p>
      </div>
      <div class="footer-links">
        <template v-if="currentRegion === 'cn'">
          <a :href="privacyPolicyUrl" target="_blank">{{ $t('message.footerPrivacyPolicy') }}</a>
          <!-- <router-link :to="`/${currentRegion}/privacy`">{{ $t('message.footerPrivacyPolicy') }}</router-link> -->
        </template>
        <template v-else>
          <router-link :to="`/${currentRegion}/privacy`">{{ $t('message.footerPrivacyPolicy') }}</router-link>
        </template>
        <span class="divider">|</span>
        <router-link :to="`/${currentRegion}/user`">{{ $t('message.footerAccountDeletion') }}</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
import { getRegionConfig } from '@/config/region/index.js'
import { CDN_BASE_URL } from '@/config/cdnConfig.js'

export default {
  name: 'Footer',
  computed: {
    currentRegion() {
      const path = this.$route.path
      if (path.startsWith('/cn')) return 'cn'
      if (path.startsWith('/global')) return 'global'
      return null
    },
    config() {
      if (!this.currentRegion) return {}
      return getRegionConfig(this.currentRegion)
    },
    privacyPolicyUrl() {
      return `${CDN_BASE_URL}/PrivacyPolicy.pdf`
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #1a1a1a;
  color: white;
  padding: 20px 0;
  margin-top: auto;
  min-height: 120px;
  display: flex;
  align-items: center;
}

.footer-content {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
  width: 100%;
}

.footer-text p {
  margin: 5px 0;
  font-size: 0.9rem;
}

.footer-text p:first-child {
  font-size: 1rem;
  margin-bottom: 10px;
}

.footer-links {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.footer-links a {
  color: #aaa;
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #4ecca3;
}

.footer-links .divider {
  color: #555;
  font-size: 0.85rem;
}
</style>